import {StateSchema} from "../../../../../app/provider/StoreProvider/config/StateSchema";


export const getCabinetData = (state: StateSchema) => state?.cabinet?.data;